'use client';
import { useEffect } from 'react';
import { PAGES } from '@/constants/pages';

export default function NotFound() {
  useEffect(() => {
    // @ts-ignore
    window.location = PAGES.HOME;
  }, []);

  return (
    <div className="w-full h-full text-2xl text-grey-7 flex items-center justify-center bg-site-background">
      Redirecting...
    </div>
  );
}
